<template>
  <div>
    <h1>Conundrum Editor</h1>
  </div>
</template>

<script>
export default {
  name: 'ConundrumEditor',
}
</script>